<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white"  :href="route('users')">Usuario</inertia-link>
      <span class="text-white font-medium">/ Crear</span> 
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-3/6" label="Nombres" required/>
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-3/6" label="Email" required/>
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-3/6" type="password" autocomplete="new-password" label="Password" required/>
          <select-input v-model="form.rol" :error="form.errors.rol" class="pr-6 pb-8 w-full lg:w-3/6 border-inexgray focus:border-inexorange" label="Rol" required>
            <option>Admin</option>
            <option>Gerente</option>
            <option>Comercio</option>
          </select-input>
          <select-input v-model="form.organization_id" :error="form.errors.forma_pago" class="pr-6 pb-8 w-full lg:w-3/6 border-inexgray focus:border-inexorange" label="Comercio" required>
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.nameCommerce }} </option>
          </select-input>  
         
        <!--  <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
        --></div>
        <div class="px-8 py-4 bg-transparent flex justify-end items-center" style="color: black;">
          <loading-button :loading="form.processing" style="color: white;" class="px-8 py-4 btn-indigoOrange" type="submit">CREAR USUARIO</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Crear Usuario' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    organizations: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        email: null,
        organization_id: null,
        password: null,
        direccion: null,
        telefono: null,
        rol: null,
        tipo: null,

      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('users.store'))
    },
  },
}
</script>
